// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "fareHead-Qba8Z";
var _3 = "groupTitle-3F7P4";
var _4 = "availabilityIcon-2j0M8";
var _5 = "serviceClass-sqfRm";
var _6 = "compareFares_cellNotFullFareConditions-1pU0y";
export { _1 as "__esModule", _2 as "fareHead", _3 as "groupTitle", _4 as "availabilityIcon", _5 as "serviceClass", _6 as "compareFares_cellNotFullFareConditions" }
export default { "__esModule": _1, "fareHead": _2, "groupTitle": _3, "availabilityIcon": _4, "serviceClass": _5, "compareFares_cellNotFullFareConditions": _6 }
